import { render, staticRenderFns } from "./Buyer.vue?vue&type=template&id=06e817d2&scoped=true"
import script from "./Buyer.vue?vue&type=script&lang=js"
export * from "./Buyer.vue?vue&type=script&lang=js"
import style0 from "./Buyer.vue?vue&type=style&index=0&id=06e817d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e817d2",
  null
  
)

export default component.exports